import { prop } from "ramda";
import {
  getLukumaarakomponentit,
  getMaaraaikakomponentit
} from "@/services/lomakkeet/rajoitteet/rajoitedialogi/tarkenninkomponentit/yhteiset/tarkenninkomponentit";

const kohdennuksenTarkenninkomponentit = {
  enintaan: getLukumaarakomponentit,
  joistaEnintaan: getLukumaarakomponentit,
  joistaVahintaan: getLukumaarakomponentit,
  lisaksiEnintaan: getLukumaarakomponentit,
  lisaksiVahintaan: getLukumaarakomponentit,
  maaraaika: getMaaraaikakomponentit,
  vahintaan: getLukumaarakomponentit
};

export const getKohdennuksenTarkenninkomponentit = (
  kohdennuksenKohdeavain,
  locale,
  inputId,
  isReadOnly = false
) => {
  if (!kohdennuksenKohdeavain) {
    return false;
  }
  const tarkenninFn = prop(
    kohdennuksenKohdeavain,
    kohdennuksenTarkenninkomponentit
  );
  return tarkenninFn(isReadOnly, {}, locale, false, inputId) || [];
};
